import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { DeudaList } from "src/app/deuda/models/deuda";
import { pagos360 } from "../models/pagos360";
import { Pagos360Service } from "./pagos360.service";
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';


export interface DialogData {
  nrocta: string;
  monto: number;
  arr: DeudaList[];
  dias: number;
  Concepto: string;
}

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}



@Component({
  selector: "app-pagos360",
  templateUrl: "./pagos360.component.html",
  styleUrls: ["./pagos360.component.scss"],
})
export class Pagos360Component implements OnInit {
  nrocta: string;
  monto: number;
  cuotasseleccionadas: DeudaList[];
  dias: number;
  Concepto: string;
  email: string;
  nombre: string;
  apellido: string;
  pagos360: pagos360;
  response: string;

  constructor(
    private service: Pagos360Service,
    public dialogRef: MatDialogRef<Pagos360Component>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.datos(data.nrocta, data.monto, data.arr, data.dias, data.Concepto);
  }

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,

  ]);

  matcher = new MyErrorStateMatcher();


  datos(nrocta: string,monto: number,k: DeudaList[],dias: number,titulo: string): void {
    debugger;
    this.nrocta = nrocta;
    this.monto = monto;
    this.cuotasseleccionadas = k;
    this.dias = dias;
    this.Concepto = titulo;
  }

  Pagar(): void {
    let tipoTributo = "";

    if (this.Concepto == "AUTOMOTORES") {
      tipoTributo = "AUAU";
    } else if (this.Concepto == "TASA POR SERVICIO A LA PROPIEDAD") {
      tipoTributo = "ININ";
    } else if (this.Concepto == "PLAN DE PAGO") {
      tipoTributo = "FIFI";
    } else if (this.Concepto == "SERVICIO DE AGUA Y CLOACAS") {
      tipoTributo = "OBSA";
    } else if (this.Concepto == "CEMENTERIO") {
      tipoTributo = "CECE";
    } else if (this.Concepto == "COMERCIO E INDUSTRIA") {
      tipoTributo = "CICI";
    }
    else if (this.Concepto == "TASAS VARIAS") {
      tipoTributo = "TAV";
    }
    // separador


    // fin

    debugger;
    var fecha = new Date(Date.now() + this.dias * 24 * 60 * 60 * 1000);
    var datosconcepto = [];

    for (var i = 0; i < this.cuotasseleccionadas.length; i++) {
      datosconcepto.push(
        "Cuota: " +
          this.cuotasseleccionadas[i].Cuota +
          " Año: " +
          this.cuotasseleccionadas[i].AnioC +
          " Importe: " +
          this.cuotasseleccionadas[i].deudaAct
      );
    }
    debugger;
    var datos = {
     
      description: this.Concepto + " " + this.nrocta + " " + datosconcepto,
      external_reference: "TRASUS",
      first_due_date:
        fecha.getDate() +
        "-" +
        (fecha.getMonth() + 1) +
        "-" +
        fecha.getFullYear(),
      first_total: this.monto,
      second_due_date:
        fecha.getDate() +
        "-" +
        (fecha.getMonth() + 1) +
        "-" +
        fecha.getFullYear(),
      second_total: this.monto,
      payer_name: this.nombre + " " + this.apellido,
      payer_email: this.emailFormControl.value,//this.email,
      back_url_success:
        "https://www.sigemyt.com/emisiondeudavscl/inicio",
      back_url_pending:
        "https://www.sigemyt.com/emisiondeudavscl/inicio",
      metadata: {
        cuotas: [],
        id_tributo: "",
        id_obligación: "",
        nro_cuenta: "",
        nro_cuota: "",
        anio_cuota: "",
        concepto: this.Concepto,
        tipo_tributo: tipoTributo,
        dias: this.dias,
      },
      excluded_channels: [],
    };

    for (var i = 0; i < this.cuotasseleccionadas.length; i++) {
      datos.metadata.cuotas.push({
        first_due_date:
          fecha.getDay() +
          1 +
          "-" +
          (fecha.getMonth() + 1) +
          "-" +
          fecha.getFullYear(),
        first_total: this.cuotasseleccionadas[i].CapitalFacturado,
        second_due_date:
          fecha.getDay() +
          1 +
          "-" +
          (fecha.getMonth() + 1) +
          "-" +
          fecha.getFullYear(),
        second_total: this.cuotasseleccionadas[i].CapitalFacturado,
        id_tributo: this.cuotasseleccionadas[i].idTributoC,
        id_obligación: this.cuotasseleccionadas[i].idObligacion,
        nro_cuenta: this.nrocta,
        first_interest: this.cuotasseleccionadas[i].Int,
        second_interest: this.cuotasseleccionadas[i].Int,
        nro_cuota: this.cuotasseleccionadas[i].Cuota,
        anio_cuota: this.cuotasseleccionadas[i].AnioC,
      });
    }

    const p = Object.assign({}, this.pagos360, datos);
    debugger;
    console.log(this.email);


    if(this.emailFormControl.value != '')
    {
      
        this.service.pagos360(p).subscribe((response) => {
          window.open(response["checkout_url"]);
        });
    //     setTimeout(()=>{                           //<<<---using ()=> syntax
    //      // window.location.href = 'https://www.sigemyt.com/emisiondeudavscl/impuestos';
    //      window.location.href = 'http://localhost:4200/impuestos';
    // }, 3000);
     
    }
    else if(this.emailFormControl.value == ''){
     console.log('ingrese un mail');
    }
    
    
   

  }
  

  limpiar(){
    this.cuotasseleccionadas = [];
  }

  ngOnInit() {}
}
